// frontend/init/index.js

import './index.css';
import './import_resource_user_views';
import './set-initial-body-classes';
import './save-local-storage-to-cookies';
import './turbolinks-cleanup';

// split-test: resource_show_modal_view
import 'components/resources/show/modal-view/setup-resource-show-modal-view';
